

(function () {
    'use strict';

    class TemplateFileCardController extends Controllers.BaseControllerES6 {

        // @ngInject
        constructor(
            $scope,
            $injector,
            $translate,
            AnalyticsService,
            TemplatesViewService,
            UsersManager,
            CompaniesManager,
            moment
        ) {
            super($scope, $injector);
            this.__objectType = 'TemplateFileCardController';
            this.moment = moment;
            this.$translate = $translate;
            this.TemplatesViewService = TemplatesViewService;
            this.AnalyticsService = AnalyticsService;
            this.user = UsersManager.getCurrUser();
            this.company = CompaniesManager.getCurrCompany();

            $scope.$watch('$ctrl.company.default_agreement', () => {
                this.shouldShowFilledStar = this.template._id === this.company.default_agreement
            });
        }

        $onInit() {
            this.isVisiblePopover = false;

            const templateIsOlderThanUser = this.moment(this.template.created_at).isBefore(this.user.created_at)
            const createdAt = templateIsOlderThanUser ? this.user.created_at : this.template.created_at;

            this.createdAtShort= this.moment(createdAt).format('MMM DD, YYYY');
            this.createdAtLong = this.moment(createdAt).format('LLLL');

            this.templateTypeName = this.template.viewModel.name === 'agreement' ? 'contract' : this.template.viewModel.name;

            this.tooltipText = this.$translate.instant('TEMPLATES_PAGE.ACTIONS._DEFAULT_');
        }

        handlePopoverClick($event) {
            $event.stopPropagation();
            this.isVisiblePopover = !this.isVisiblePopover;
        }

        isDefaultable() {
            return this.TemplatesViewService.isTemplateTypeDefaultable(this.template.viewModel);
        }

        isCloneable() {
            return this.TemplatesViewService.isTemplateTypeCloneable(this.template.viewModel, this.template);
        }

        isDeletable() {
            return this.TemplatesViewService.isTemplateTypeDeletable(this.template.viewModel, this.template);
        }

        onDefaultClick($event) {
            $event.preventDefault();
            $event.stopPropagation();
            if (this.onDefault && angular.isFunction(this.onDefault)) {
                this.onDefault({ template: this.template });
            }
        }

        onSelectClick($event) {
            $event.stopPropagation();
            if (this.onSelect && angular.isFunction(this.onSelect)) {
                this.onSelect({ template: this.template });
            }
        }

        onCloneClick($event) {
            $event.preventDefault();
            $event.stopPropagation();
            this.isVisible = false;
            if (this.onClone && angular.isFunction(this.onClone)) {
                this.onClone({ template: this.template });
            }
        }

        onDeleteClick($event) {
            $event.preventDefault();
            $event.stopPropagation();
            this.isVisible = false;
            if (this.onDelete && angular.isFunction(this.onDelete)) {
                this.onDelete({ template: this.template});
            }
        }

        clickOutside() {
            this.isVisiblePopover = false;
        }

        shouldShowDropdown(template) {
            return template && (template.key !== 'emailSignature');
        }

        handleMouseLeave() {
            this.isVisiblePopover = false;
        }

    }

    Components.TemplateFileCard = {
        bindings: {
            template: '<',
            templateIdIsLoading: '<',
            onDelete: '&',
            onDefault: '&',
            onSelect: '&',
            onClone: '&',
            templateFileListView: '<',
        },
        controller: TemplateFileCardController,
        name: 'hbTemplateFileCard',
        templateUrl: 'angular/app/modules/core/features/company_settings/templates/template_file_card/template_file_card.html'
    };

}());